"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var mobx_react_1 = require("mobx-react");
var store_component_1 = __importDefault(require("@hikakaku/shared/components/estimate_form/common/store_component"));
var NestedSingleSelectInput = (0, mobx_react_1.observer)(function (_a) {
    var _b;
    var store = _a.store;
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement("div", { className: "estimateForm-NestedSingleSelect_Wrapper" },
            !store.hidden &&
                react_1.default.createElement("select", { value: store._value /* 子供の要素が選択されている時は子供のvalueを返すため直接 _value を参照する*/, onChange: store.handleChange, onBlur: store.handleBlur, className: "estimateForm-NestedSingleSelect" },
                    react_1.default.createElement("option", { value: "" }, "\u9078\u629E\u3057\u3066\u304F\u3060\u3055\u3044"),
                    store.optionStores.map(function (option, idx) { return (react_1.default.createElement("option", { key: idx, value: option.value }, option.label)); })),
            store.depth === 0 &&
                react_1.default.createElement("div", { className: "estimateForm-NestedSingleSelect_ClearButtonWrapper" },
                    react_1.default.createElement("i", { onClick: store.clear, className: "jirafficon jirafficon-close estimateForm-NestedSingleSelect_ClearButton" }),
                    store.clearButtonHelpText &&
                        react_1.default.createElement("span", { className: "estimateForm-NestedSingleSelect_ClearButtonHelp" }, store.clearButtonHelpText))),
        ((_b = store.selectedOptionStore) === null || _b === void 0 ? void 0 : _b.nestedSelectInputStore) &&
            react_1.default.createElement(store_component_1.default, { store: store.selectedOptionStore.nestedSelectInputStore })));
});
exports.default = NestedSingleSelectInput;
